import React, { useEffect, useState } from "react";
import withStyles from '@mui/styles/withStyles';
import WhiteBox from "../shared/white-box";
import PointsRouteLink from "./points-route-link";
import PointsRouteView from "./points-route-view";
import { useHistory } from "react-router-dom";
const styles = (theme) => ({
  root: {
    color: "#fff",
    height: 800,
    position: "relative",
  },
  whiteBox: {
    zIndex: 3,
    backgroundColor: "black",
    position: "absolute",
    width: "100%",
    height: 100,
  },
  contentWrapper: {
    width: "100%",
    zIndex: 2,
    position: "absolute",
  },
  content: {
    marginTop: 200,
  },
  routeGroupWrapper: {
    overflow: "hidden",
  },
  routeGroup: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100vw",
  },
});

const Points = ({
  classes,
  match: {
    params: { subRoute },
  },
}) => {
  const [routeName, setRouteName] = useState(subRoute ?? "coupons");
  let history = useHistory();
  useEffect(() => {
    history.replace({ pathname: `/points/${routeName}` });
  }, [history, routeName]);

  return (
    <div data-testid="achievements">
      <div className="scrollable" datatest-id="achievements">
        <div className={classes.root}>
          <WhiteBox text="Meine Erfolge" className={classes.whiteBox}>
            <div className={classes.routeGroupWrapper}>
              <div className={classes.routeGroup}>
                <PointsRouteLink
                  selectedRouteName={routeName}
                  routeName="coupons"
                  title={"Punkte einlösen"}
                  setRouteName={setRouteName}
                />
                <PointsRouteLink
                  selectedRouteName={routeName}
                  routeName="achievements"
                  title={"Punkte - übersicht"}
                  setRouteName={setRouteName}
                />
                <PointsRouteLink
                  selectedRouteName={routeName}
                  routeName="my-coupons"
                  title={"Meine Coupons"}
                  setRouteName={setRouteName}
                />
              </div>
            </div>
          </WhiteBox>
          <div className={classes.contentWrapper}>
            <PointsRouteView routeName={routeName} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default withStyles(styles)(Points);
